import React from "react"
import { Outlet, Link } from "react-router-dom";

const Footer = () => {

    const privacy = "Privacy Notice "
    const use = " Terms of use"

    return (
        <footer className="bg-primary text-white py-2 px-4 d-flex justify-content-between align-items-center">
            <span>© {new Date().getFullYear()} Aenduo S.r.l.</span>
            <span>
                <Link to="/privacy-policy" className="text-white text-decoration-none">{privacy}</Link>
                <span className="mx-2">|</span>
                <Link to="/terms-of-use" className="text-white text-decoration-none">{use}</Link>
            </span>
        </footer>
    )
}

export default Footer
